import React from "react";

const FileDownloader = ({ fileUrl, fileName = "download" }) => {
  const handleDownload = async () => {
    if (!fileUrl) {
      console.error("No file URL provided");
      return;
    }

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const fileExtension = fileUrl.split(".").pop();
      const mimeType =
        blob.type ||
        (fileExtension === "pdf" ? "application/pdf" : "image/jpeg");

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.${fileExtension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <button className="btn btn-primary" onClick={handleDownload}>
      DOWNLOAD BILL
    </button>
  );
};

export default FileDownloader;
